/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LowInputs */

const en_low = /** @type {(inputs: LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

const th_low = /** @type {(inputs: LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต่ำ`)
};

const ja_low = /** @type {(inputs: LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低`)
};

const fr_low = /** @type {(inputs: LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faible`)
};

const es_low = /** @type {(inputs: LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajo`)
};

const ru_low = /** @type {(inputs: LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Низкий`)
};

const zh_low = /** @type {(inputs: LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低`)
};

const vi_low = /** @type {(inputs: LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thấp`)
};

/**
* | output |
* | --- |
* | "Low" |
*
* @param {LowInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const low = /** @type {((inputs?: LowInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LowInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_low(inputs)
	if (locale === "ja") return ja_low(inputs)
	if (locale === "fr") return fr_low(inputs)
	if (locale === "es") return es_low(inputs)
	if (locale === "ru") return ru_low(inputs)
	if (locale === "zh") return zh_low(inputs)
	if (locale === "vi") return vi_low(inputs)
	return en_low(inputs)
});